export const getOverlayOpacity = (opacity) => {
  if (opacity === undefined || opacity === null) return 0.7;
  const parsed = parseFloat(opacity);
  if (isNaN(parsed) || parsed < 0 || parsed > 1) return 0.7;
  return parsed;
};

export const getOverlayColor = (theme) => {
  return (theme && theme.colors && theme.colors.surface && theme.colors.surface.base) || '#ffffff';
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingContainer/utils/loadingContainerHelpers.js